import { PathName } from './PathName';

export enum Paths {
  Index = '/',
  Login = '/login',
  Docs = '/docs',
  DocsDetail = '/docs/[pageId]',
  ERROR503 = '/503',
  SignupWithOAuth = '/signup/[provider]',
  SignupWithGoogle = '/signup/google',
  SignupWithMicrosoft = '/signup/microsoft',
  SignupWithEmail = '/signup/email',
  Verify = '/verify',
  Verify2FA = '/verify/2fa',
  VerifyEmail = '/verify/2fa/email',
  Join = '/join',
  WorkspaceIndex = '/w',
  GettingStarted = '/w/getting-started',
  CreateWorkspace = '/w/getting-started/new',
  Calls = '/w/[workspaceId]',
  RecordDetail = '/w/[workspaceId]/record/[recordId]',
  Member = '/w/[workspaceId]/member',
  Team = '/w/[workspaceId]/team',
  Automation = '/w/[workspaceId]/automation',
  Label = '/w/[workspaceId]/label',
  Config = '/w/[workspaceId]/config',
  Setting = '/w/[workspaceId]/setting',
  Integration = '/w/[workspaceId]/setting/integration',
  AdminDashboard = '/w/[workspaceId]/admin/dashboard',
  License = '/w/[workspaceId]/license',
  My = '/w/[workspaceId]/my',
  ForgotPassword = '/user/password/forgot',
  ResetPassword = '/user/password/reset',
  RegisterPassword = '/user/password/register',
  Withdraw = '/user/withdraw',
  IntegrationGoogleCalendar = '/integration/google-calendar',
  IntegrationOutlookCalendar = '/integration/outlook-calendar',
  IntegrationMSTeams = '/integration/ms-teams',
  IntegrationNotion = '/integration/notion',
  IntegrationLinear = '/integration/linear',
  IntegrationConfluence = '/integration/confluence',
  IntegrationSalesforce = '/integration/salesforce',
  IntegrationPipedrive = '/integration/pipedrive',
  IntegrationSlack = '/integration/slack',
  IntegrationSlackChannel = '/integration/slack-channel',
  TermService = '/terms/service',
  TermPrivacy = 'https://plip.kr/pcc/72a115cc-40a4-4151-bf4b-a9087a1f7162/privacy-policy', // TODO: 외부링크이긴한데 코드 수정 최소화를 위해 우선은 여기에 둠
  TermCRMAddEndum = '/terms/addendum_save_phone_number',
  SharedRecords = '/w/[workspaceId]/share',
  ShareIndex = '/w/[workspaceId]/s',
  Share = '/w/[workspaceId]/s/[sharedId]',
  Events = '/w/[workspaceId]/events',
  // UsageDashboard = '/w/[workspaceId]/usage',
  NoticeForStripe = '/stripe-notice',
  Roles = '/w/[workspaceId]/roles',
  RolesForm = '/w/[workspaceId]/roles/roles-form',
  TeamMeeting = '/w/[workspaceId]/teams/[teamId]/meeting',
  TeamMember = '/w/[workspaceId]/teams/[teamId]/member',
  TeamAutomation = '/w/[workspaceId]/teams/[teamId]/automation',
  TeamConfig = '/w/[workspaceId]/teams/[teamId]/config',
  MyMeetings = '/w/[workspaceId]/my-meetings',
  AuditLogs = '/w/[workspaceId]/audit-logs',
}

export enum HomePaths {
  Recording = '/recording',
  Insight = '/insight',
  Pricing = '/pricing',
  Security = '/security',
  IntegrationsIndex = '/integrations',
  IntegrationsGoogleCalendar = '/integrations/google-calendar',
  IntegrationsOutlookCalendar = '/integrations/outlook-calendar',
  IntegrationsSalesforce = '/integrations/salesforce',
  IntegrationsPipedrive = '/integrations/pipedrive',
  IntegrationsSlack = '/integrations/slack',
  IntegrationsZapier = '/integrations/zapier',
  IntegrationsNotion = '/integrations/notion',
  IntegrationsTeams = '/integrations/teams',
  IntegrationsHubspot = '/integrations/hubspot',
  IntegrationsConfluence = '/integrations/confluence',
  IntegrationsLinear = '/integrations/linear',
}

export enum PathsForExternal {
  GooglePlayStore = 'https://play.google.com/store/apps/details?id=ai.rtzr.callabo',
  AppleAppStore = 'https://apps.apple.com/kr/app/callabo/id6445909567',
  ChromeExtension = 'https://chrome.google.com/webstore/detail/callabo-%EC%BD%9C%EB%9D%BC%EB%B3%B4-%EC%84%B8%EC%9D%BC%EC%A6%88%EC%BD%9C%EC%97%90%EC%84%9C-%EC%B0%BE%EB%8A%94-%EB%A7%A4%EC%B6%9C/dalcbknelnfobfkkhefbbhhfpdiibhgn?hl=ko&authuser=0',
  WhatTime = 'https://whattime.co.kr/callabo/onboarding',
  Email = 'mailto:callabo@rtzr.ai',
  Blog = 'https://callabo.ai/blog',
  IntroductionDocsForKO = 'https://sclu.io/share/bulk/file/8f044625d5132957',
  IntroductionDocsForJA = 'https://sclu.io/share/bulk/file/2d0a7879adc8d4a7',
  LinkedIn = 'https://www.linkedin.com/in/callabo-ai-985734262/',
  RTZR = 'https://www.rtzr.ai/',
  PricingGoogleForm = 'https://forms.gle/PZ114h7GNtrGqzck9',
  GoogleCalendar = 'https://calendar.google.com/calendar/',
  OutLookCalendar = 'https://outlook.office365.com/calendar/view/month',
  ChannelTalk = 'https://callabo.channel.io',
  WebhookGuide = 'https://rtzr.notion.site/Callabo-Webhook-1ae3077f85aa804abe9ad2c8af16fadc?pvs=74',
  UseCase = 'https://callabo.ai/blog/category/use-case',
}

/**
 * @deprecated {@link PathName}을 활용해주세요.
 */
export function replaceWorkspaceId(path: Paths, workspaceId: string): string {
  return new PathName(path).setWorkspaceId(workspaceId).toString();
}

export const CALLABO_API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL as string;
